<div class="page-layout simple fullwidth" fusePerfectScrollbar>
    <mat-tab-group>
        <mat-tab label="Pending Alerts">
            <alert-list [alerts]=alerts [resolved]='false'></alert-list>        
        </mat-tab>
        <mat-tab label="Alerts Log">
            <alert-list [alerts]=alerts [resolved]='true'></alert-list>        
        </mat-tab>
    </mat-tab-group>
</div>